import * as backend from './backend-types';

function toPhoneNumberRequest(
  phoneNumber?: backend.PortalPhoneNumberResponse,
): backend.PortalPhoneNumberRequest | undefined {
  if (!phoneNumber) return undefined;
  // Response has the country name in `countryCode` and the numeric code in
  // `callingCode`; the request wants the numeric one.
  const countryCode =
    phoneNumber.callingCode !== undefined && phoneNumber.callingCode !== null
      ? String(phoneNumber.callingCode)
      : phoneNumber.countryCode;
  if (!countryCode) return undefined;
  return {
    countryCode,
    number: phoneNumber.number,
  };
}

function toCareDataRequest(
  careData?: backend.PortalCareDataResponse,
): backend.PortalCareDataRequest | undefined {
  if (!careData) return undefined;
  return {
    generalPractitioner: careData.generalPractitioner,
    phoneNumber: toPhoneNumberRequest(careData.phoneNumber || undefined),
    medicalDetails: careData.medicalDetails,
  };
}

export function buildClientUpdateRequest(
  client: backend.PortalClientResponse,
  clinicalUnitId?: string | null,
  cohortId?: string | null,
): backend.PortalClientRequest {
  const personalData = client.personalData || {};
  const address = personalData.address || {};
  return {
    firstName: personalData.firstName || 'Unknown',
    lastName: personalData.lastName || 'Unknown',
    dateOfBirth: personalData.dateOfBirth,
    email: personalData.email,
    externalPatientId: client.externalPatientId,
    clinicalUnitId,
    cohortId,
    phoneNumber: toPhoneNumberRequest(personalData.phoneNumber),
    address: {
      street: address.street || 'Unknown street',
      houseNumber: address.houseNumber || '1',
      postcode: address.postcode || '00000',
      city: address.city || 'Unknown city',
      country: address.country || 'Unknown country',
    },
    careData: toCareDataRequest(personalData.careData),
    locale: client.locale,
    profileVersion: client.profileVersion,
  };
}
